
<template>
  <div class="home-container">
    <div class="banner-container">
      <div class="banner">
        <div class="banner-msg">
          <div class="main-title">
            <label>精准</label>
            <span>●</span>
            <label>便利</label>
            <span>●</span>
            <label>省钱</label>
          </div>
          <div class="sub-title">
            传承精华, 守正创新
          </div>
        </div>
      </div>
    </div>
    <div style="padding-top: 140px; padding-bottom: 140px">
      <el-row>
        <el-col :span="8" class="cmp-container">
          <img src="../assets/images/home_cmp_01.png" class="cmp-img">
          <div class="cmp-title">自助挂号便捷化</div>
        </el-col>
        <el-col :span="8" class="cmp-container">
          <img src="../assets/images/home_cmp_02.png" class="cmp-img">
          <div class="cmp-title">智能诊疗精准化</div>
        </el-col>
        <el-col :span="8" class="cmp-container">
          <img src="../assets/images/home_cmp_03.png" class="cmp-img">
          <div class="cmp-title">绿洲报销实时化</div>
        </el-col>
      </el-row>
    </div>

    <el-dialog @closed="doDialogDidClosed" title="" :visible.sync="isShowDialog" :close-on-click-modal="false" :show-close="false">
      <div slot="title"></div>
      <div>
                <span class="dialog-close-btn" @click="doCloseAction">
                    <i class="el-icon-close"></i>
                </span>

        <div class="declaration-container">
          <div class="title">提示</div>
          <p class="content">
            绿洲智能医生系统是依据《黄帝内经》、《伤寒杂病论》、《神农本草经》、《系统医学导论》开发而成，其将医学状态分析归纳为非常筒洁的数十条底层逻辑规则对诊、疗提出方案。绿洲智能医生系统旨在为您提供高质、便利、低价的服务，对医疗背景空缺的普通大众进行咨询性指导，让患者尽快恢复健康、远离疾病的困扰。本系统无意替代专业医生的职责，所提供的信息仅供参考，不能作为诊断及医疗依据。专此声明。
          </p>
        </div>

        <div class="dialog-footer">
          <div style="padding-top: 10px">
            <label @click="isAccept = !isAccept">
                        <span
                          style="background-color: white; padding-left: 2px; padding-right: 2px; border-radius: 3px; border: 1px solid #e4e4e4; position: relative; top: -1px">
                            <i class="el-icon-check" style="color: #FFAB48" v-if="isAccept"></i>
                            <i class="el-icon-check" style="color: white" v-else></i>
                        </span>
              <span style="font-weight:400;color:rgba(102,102,102,1); margin-left: 6px; font-size: 18px">同意免责声明</span>
            </label>
          </div>

          <div style="padding-top: 20px;">
            <el-button type="primary"
                       :disabled="!isAccept"
                       @click="doStartDiagnose"
                       style="width: 300px; height: 50px">
              <span style="font-size: 16px; color: white">开始分析</span>
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name: 'Home',
  data () {
    return {
    }
  },
  computed: {
    isLogined: function () {
      return this.$store.getters.isLogined
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style scoped>
  .home-container {
    position: relative;
  }

  .banner-container {
    position: relative;
    background-image: url("../assets/images/home_banner.png");
    background-color: #2ECE6F;
    height: 400px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    min-width: 992px;
  }

  .banner {
    margin: 0 auto;
    min-height: 400px;
    position: relative;
  }

  .banner-msg {
    position: absolute;
  }

  .header-container #appLogo {
    position: absolute;
    top: 20px;
    left: 0px;
  }

  @media only screen and (min-width: 992px) {
    .banner {
      max-width: 992px;
    }
  }

  @media only screen and (min-width: 1200px) {
    .banner {
      max-width: 1200px;
    }
  }

  .main-title {
    padding-top: 120px;
  }

  .main-title label {
    font-size: 44px;
    font-weight: 400;
    color: rgba(255, 254, 254, 1);
  }

  .main-title span {
    font-size: 10px;
    font-weight: 400;
    color: rgba(255, 254, 254, 1);
    margin-left: 4px;
    margin-right: 4px;
  }

  .sub-title {
    padding-top: 16px;
    font-size: 37px;
    font-weight: 400;
    color: rgba(255, 254, 254, 1);
  }

  .declaration-container {
    margin-top: -30px;
    padding-left: 16px;
    padding-right: 16px;
  }

  .declaration-container .title {
    font-size: 24px;
    font-weight: bold;
    color: rgba(46, 206, 111, 1);
    margin-bottom: 16px;
  }

  .declaration-container .content {
    font-size: 20px;
    font-weight: 400;
    color: rgba(102, 102, 102, 1);
    line-height: 36px;
  }

  .dialog-footer {
    margin-top: 0px;
    /*background-color: #EEEEEE;*/
    height: 160px;
    text-align: center;
    position: relative;
    left: -20px;
    margin-right: -40px;
    bottom: -30px;
    /*right: 100px;*/
  }

  .dialog-close-btn {
    position: absolute;
    right: 30px;
    top: 24px;
    background-color: white;
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
  }

  .dialog-close-btn i {
    color: darkgrey;
    font-weight: 300;
    font-size: 26px;
  }

  .dialog-close-btn i:hover {
    color: lightgray;
  }
  .diagnose-type-container td {
    border: 0px solid #8c939d;
    width: 120px;
  }
  .cmp-container {
    text-align: center;
  }
  .cmp-img {
    width: 144px;
    height: 144px;
    display: inline-block;
  }
  .cmp-title {
    font-size:20px;
    font-weight:400;
    color:rgba(102,102,102,1);
    line-height:24px;
    text-align: center;
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue